import React from 'react';

// The two animated figures of the Inspect landing page: the hero story (the app saves a Daily Pre-Start,
// it is graded Pass, a Pass row appears in the dashboard's History tab) and the crews story (scan the
// slate, tap the inspection, fill it in and save). Drawn in HTML with made-up demo data, so both themes and
// the save animation keep working; every word goes through t, every direct child is aria-hidden and the figure carries the text as its aria-label.
// props: t, waiting (adds inspect-landing-wait until the figure scrolls into view), figureRef (callback ref).

// The History rows under the new entry: asset, inspection, chip class, chip label.
var HISTORY_ROWS = [
  ['artReachTruck', 'artWeeklySafety', 'fail', 'chipFail'],
  ['artTelehandler', 'artDailyPreStart', 'corrected', 'chipCorrected'],
  ['artForklift7', 'artDailyPreStart', 'pass', 'chipPass'],
  ['artScissorLift', 'artMonthlyService', 'incomplete', 'chipIncomplete'],
  ['artBoomLift', 'artWeeklySafety', 'pass', 'chipPass'],
];

export function HeroArt(props) {
  var t = props.t;
  return (
    <div
      className={
        'inspect-landing-figure inspect-landing-k-show inspect-landing-hero-art' +
        (props.waiting ? ' inspect-landing-wait' : '')
      }
      ref={props.figureRef}
      role="img"
      aria-label={t('inspectLanding:heroArtLabel')}
    >
      <div className="inspect-landing-k-hist" aria-hidden="true">
        <div className="inspect-landing-k-tabs">
          <span className="inspect-landing-k-tab">
            <span className="material-symbols-outlined">monitoring</span>
            {t('inspectLanding:artPerformance')}
          </span>
          <span className="inspect-landing-k-tab inspect-landing-k-tab-on">
            <span className="material-symbols-outlined">history</span>
            {t('inspectLanding:artHistory')}
          </span>
          <span className="inspect-landing-k-tab">
            <span className="material-symbols-outlined">calendar_month</span>
            {t('inspectLanding:artScheduled')}
          </span>
        </div>
        <div className="inspect-landing-k-grid inspect-landing-k-th">
          <span>{t('inspectLanding:artColAsset')}</span>
          <span>{t('inspectLanding:artColInspection')}</span>
          <span>{t('inspectLanding:artColResult')}</span>
        </div>
        <div className="inspect-landing-k-new">
          <div className="inspect-landing-k-grid inspect-landing-k-tr">
            <span className="inspect-landing-k-cell">{t('inspectLanding:artForklift')}</span>
            <span className="inspect-landing-k-cell">{t('inspectLanding:artDailyPreStart')}</span>
            <span>
              <span className="inspect-result-badge pass">{t('inspectLanding:chipPass')}</span>
            </span>
          </div>
        </div>
        {HISTORY_ROWS.map(function (row, i) {
          return (
            <div
              key={row[0]}
              className={'inspect-landing-k-grid inspect-landing-k-tr' + (i % 2 === 0 ? ' inspect-landing-k-alt' : '')}
            >
              <span className="inspect-landing-k-cell">{t('inspectLanding:' + row[0])}</span>
              <span className="inspect-landing-k-cell">{t('inspectLanding:' + row[1])}</span>
              <span>
                <span className={'inspect-result-badge ' + row[2]}>{t('inspectLanding:' + row[3])}</span>
              </span>
            </div>
          );
        })}
      </div>
      <div className="inspect-landing-k-phone" aria-hidden="true">
        <div className="inspect-landing-k-scr">
          <div className="inspect-landing-k-shead">
            <span className="material-symbols-outlined">assignment</span>
            <span className="inspect-landing-k-stitle">
              {t('inspectLanding:artDailyPreStart')}
            </span>
            <span className="inspect-landing-k-sdone">{t('inspectLanding:artDone')}</span>
          </div>
          <div className="inspect-landing-k-sbody">
            <div className="inspect-landing-k-sstat">
              <div className="inspect-landing-k-stat-h">
                <span className="material-symbols-outlined">checklist</span>
                {t('inspectLanding:artInspection')}
              </div>
              <div className="inspect-landing-k-stat-c">
                <span style={{ flex: '1 1 auto', minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 6 }}>
                  <span className="inspect-landing-ac inspect-landing-ac-pass">
                    {t('inspectLanding:chipPass')}
                  </span>
                  <span className="inspect-landing-k-by">
                    <span className="inspect-landing-k-av" style={{ flexBasis: 10, width: 10, height: 10 }} />
                    <span className="inspect-landing-k-bar-d">{t('inspectLanding:artInspector')}</span>
                  </span>
                </span>
                <span className="material-symbols-outlined">chevron_right</span>
              </div>
            </div>
            <span className="inspect-landing-k-sgroup">{t('inspectLanding:artGroupSafety')}</span>
            <div className="inspect-landing-k-scard">
              <div className="inspect-landing-k-srow">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab">{t('inspectLanding:artCheckBrakes')}</span>
                <span className="inspect-landing-k-valswap">
                  <span className="inspect-landing-k-slider inspect-landing-k-ss">
                    <span className="inspect-landing-k-thumb inspect-landing-k-t1" />
                  </span>
                  <span className="inspect-landing-k-val inspect-landing-k-yes inspect-landing-k-sp" />
                </span>
              </div>
              <div className="inspect-landing-k-srow">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab">{t('inspectLanding:artCheckHorn')}</span>
                <span className="inspect-landing-k-valswap">
                  <span className="inspect-landing-k-slider inspect-landing-k-ss">
                    <span className="inspect-landing-k-thumb inspect-landing-k-t2" />
                  </span>
                  <span className="inspect-landing-k-val inspect-landing-k-yes inspect-landing-k-sp" />
                </span>
              </div>
              <div className="inspect-landing-k-srow">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab">{t('inspectLanding:artCheckLights')}</span>
                <span className="inspect-landing-k-valswap">
                  <span className="inspect-landing-k-slider inspect-landing-k-ss">
                    <span className="inspect-landing-k-thumb inspect-landing-k-t3" />
                  </span>
                  <span className="inspect-landing-k-val inspect-landing-k-yes inspect-landing-k-sp" />
                </span>
              </div>
              <div className="inspect-landing-k-srow">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab">{t('inspectLanding:artCheckForks')}</span>
                <span className="inspect-landing-k-valswap">
                  <span className="inspect-landing-k-slider inspect-landing-k-ss">
                    <span className="inspect-landing-k-thumb inspect-landing-k-t4" />
                  </span>
                  <span className="inspect-landing-k-val inspect-landing-k-yes inspect-landing-k-sp" />
                </span>
              </div>
            </div>
            <div className="inspect-landing-k-sfoot">
              <div className="inspect-landing-k-ssave">
                <span className="material-symbols-outlined inspect-landing-fill">save</span>
                {t('inspectLanding:artSaveEntry')}
                <span className="inspect-landing-k-tapring" />
              </div>
              <div className="inspect-landing-k-ssaved">
                <span className="material-symbols-outlined">check_circle</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function CrewArt(props) {
  var t = props.t;
  return (
    <div
      className={
        'inspect-landing-figure inspect-landing-crew-art' +
        (props.waiting ? ' inspect-landing-wait' : '')
      }
      ref={props.figureRef}
      role="img"
      aria-label={t('inspectLanding:crewArtLabel')}
    >
      <div className="inspect-landing-k-phone" aria-hidden="true">
        <div className="inspect-landing-k-scr">
          <div className="inspect-landing-c7-slate">
            <div className="inspect-landing-c7-bar">
              <span className="material-symbols-outlined">arrow_back</span>
              <span className="inspect-landing-c7-bar-t">{t('inspectLanding:artForklift')}</span>
              <span className="material-symbols-outlined inspect-landing-fill">settings</span>
            </div>
            <span className="inspect-landing-c7-gbar" style={{ top: 54 }}>{t('inspectLanding:artGroupDetails')}</span>
            <div className="inspect-landing-c7-card" style={{ top: 74 }}>
              <div className="inspect-landing-c7-f">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab">{t('inspectLanding:artFieldType')}</span>
                <span className="inspect-landing-c7-v">{t('inspectLanding:artValueType')}</span>
              </div>
              <div className="inspect-landing-c7-rec">
                <span className="material-symbols-outlined inspect-landing-c7-rec-i">
                  assignment
                </span>
                <span className="inspect-landing-c7-rec-h">
                  <span className="inspect-landing-c7-rec-t">
                    {t('inspectLanding:artDailyPreStart')}
                  </span>
                  <span className="inspect-landing-c7-count">
                    {t('inspectLanding:artCount')}
                    <span className="material-symbols-outlined">arrow_forward_ios</span>
                  </span>
                </span>
                <span className="inspect-landing-c7-add">
                  <span className="material-symbols-outlined">add</span>
                  {t('inspectLanding:artDailyPreStart')}
                  <span className="inspect-landing-c7-tapring inspect-landing-c7-tap-b" />
                </span>
                <span className="inspect-landing-c7-last">
                  <span className="inspect-landing-k-av" />
                  <span className="inspect-landing-c7-name">{t('inspectLanding:artInspector')}</span>
                  <span className="inspect-landing-c7-when">
                    <span className="inspect-landing-c7-old">
                      {t('inspectLanding:artDayAgo')}
                    </span>
                    <span className="inspect-landing-c7-new">
                      {t('inspectLanding:artMomentAgo')}
                    </span>
                  </span>
                </span>
              </div>
              <div className="inspect-landing-c7-f">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab">{t('inspectLanding:artFieldLocation')}</span>
                <span className="inspect-landing-c7-v">{t('inspectLanding:artValueLocation')}</span>
              </div>
            </div>
            <span className="inspect-landing-c7-gbar" style={{ top: 264 }}>{t('inspectLanding:artGroupService')}</span>
            <div className="inspect-landing-c7-card" style={{ top: 284 }}>
              <div className="inspect-landing-c7-f">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab">{t('inspectLanding:artFieldHours')}</span>
                <span className="inspect-landing-c7-v">{t('inspectLanding:artValueHours')}</span>
              </div>
              <div className="inspect-landing-c7-f">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab">{t('inspectLanding:artFieldService')}</span>
                <span className="inspect-landing-c7-v">{t('inspectLanding:artValueService')}</span>
              </div>
            </div>
          </div>
          <div className="inspect-landing-c7-sheet">
            <div className="inspect-landing-k-shead">
              <span className="material-symbols-outlined">assignment</span>
              <span className="inspect-landing-k-stitle">
                {t('inspectLanding:artDailyPreStart')}
              </span>
              <span className="inspect-landing-k-sdone">{t('inspectLanding:artDone')}</span>
            </div>
            <div className="inspect-landing-c7-sbody">
              <span className="inspect-landing-c7-gbar" style={{ top: 10 }}>{t('inspectLanding:artGroupSafety')}</span>
              <div className="inspect-landing-c7-card" style={{ top: 30 }}>
                <div className="inspect-landing-k-srow">
                  <span className="inspect-landing-k-ico" />
                  <span className="inspect-landing-k-lab">{t('inspectLanding:artCheckBrakes')}</span>
                  <span className="inspect-landing-k-slider">
                    <span className="inspect-landing-k-thumb inspect-landing-c7-t1" />
                  </span>
                </div>
                <div className="inspect-landing-k-srow">
                  <span className="inspect-landing-k-ico" />
                  <span className="inspect-landing-k-lab">{t('inspectLanding:artCheckHorn')}</span>
                  <span className="inspect-landing-k-slider">
                    <span className="inspect-landing-k-thumb inspect-landing-c7-t2" />
                  </span>
                </div>
                <div className="inspect-landing-k-srow">
                  <span className="inspect-landing-k-ico" />
                  <span className="inspect-landing-k-lab">{t('inspectLanding:artCheckLights')}</span>
                  <span className="inspect-landing-k-slider">
                    <span className="inspect-landing-k-thumb inspect-landing-c7-t3" />
                  </span>
                </div>
                <div className="inspect-landing-k-srow">
                  <span className="inspect-landing-k-ico" />
                  <span className="inspect-landing-k-lab">{t('inspectLanding:artCheckForks')}</span>
                  <span className="inspect-landing-k-slider">
                    <span className="inspect-landing-k-thumb inspect-landing-c7-t4" />
                  </span>
                </div>
              </div>
              <div className="inspect-landing-c7-foot">
                <div className="inspect-landing-c7-save">
                  <span className="material-symbols-outlined inspect-landing-fill">save</span>
                  {t('inspectLanding:artSaveEntry')}
                  <span className="inspect-landing-c7-tapring inspect-landing-c7-tap-c" />
                </div>
                <div className="inspect-landing-c7-saved">
                  <span className="material-symbols-outlined">check_circle</span>
                </div>
              </div>
            </div>
          </div>
          <div className="inspect-landing-c7-scan">
            <div className="inspect-landing-c7-scan-top">
              <span className="inspect-landing-c7-logo" />
              <span className="inspect-landing-c7-me" />
            </div>
            <div className="inspect-landing-c7-asset" />
            <div className="inspect-landing-c7-qr">
              <span className="material-symbols-outlined">qr_code_2</span>
            </div>
            <div className="inspect-landing-c7-frame">
              <span className="inspect-landing-c7-cn inspect-landing-c7-tl" />
              <span className="inspect-landing-c7-cn inspect-landing-c7-tr" />
              <span className="inspect-landing-c7-cn inspect-landing-c7-bl" />
              <span className="inspect-landing-c7-cn inspect-landing-c7-br" />
            </div>
            <span className="inspect-landing-c7-gohome">{t('inspectLanding:artGoHome')}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
